import { render } from "./TasterPack.vue?vue&type=template&id=d3559840&scoped=true"
import script from "./TasterPack.vue?vue&type=script&lang=js"
export * from "./TasterPack.vue?vue&type=script&lang=js"

import "./TasterPack.vue?vue&type=style&index=0&id=d3559840&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3559840"]])

export default __exports__